import Button from "@mui/material/Button";
import React from "react";
import { useNavigate } from "react-router";

export default function StepperButton({
	activeStep,
	setActiveStep,
	size,
	disabled,
	submitStatus,
}) {
	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const navigate = useNavigate();

	const handleBack = () => {
		submitStatus
			? navigate("..")
			: setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	return (
		<>
			<Button
				disabled={activeStep === 0}
				variant="outlined"
				size="small"
				color=""
				onClick={handleBack}
			>
				{submitStatus ? "Fermer" : "Retour"}
			</Button>
			{activeStep !== size && (
				<Button
					variant="contained"
					disabled={disabled}
					size="small"
					type={activeStep === size ? "submit" : "button"}
					onClick={handleNext}
					color="secondary"
				>
					Suivant
				</Button>
			)}
		</>
	);
}
